import styled, { css } from 'styled-components';

interface BaseAssetProps {
    // TODO: Should use `$` prefix.
    $isSold?: boolean;
    $dataSrc?: string;
    $objectFit?: 'cover' | 'contain';
}

const BaseAssetStyles = css<BaseAssetProps>`
    display: block;
    width: 100%;

    aspect-ratio: 1/1;
    border-radius: 6px;
    opacity: ${({ $isSold }) => ($isSold ? 0.3 : undefined)};

    object-fit: ${({ $objectFit }) => $objectFit || 'cover'};
`;

export const StyledVideo = styled.video<BaseAssetProps>`
    && {
        ${BaseAssetStyles}
    }
`;

export const StyledImage = styled.img<BaseAssetProps>`
    && {
        ${BaseAssetStyles}
        ${({ $dataSrc }) =>
            !$dataSrc &&
            css`
                visibility: hidden;
            `}
    }
`;
